import { useApiClient } from './apiClient';

export const useForgotLoginApis = () => {
  const { post, putR } = useApiClient();

  const RequestSecurityCode = async (username) => {
    try {
      return await post(`api/auth/password-recovery/request?username=${username}`);
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const VerifySecurityCode = async (username, code) => {
    try {
      return await post(`api/auth/password-recovery/verify?username=${username}&code=${code}`);
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const updateForgotPassword = async (user) => {
    try {
      return await putR('api/auth/password-recovery/setpassword', user);
    } catch (err) {
      console.error('Error updating user:', err);
      return false;
    }
  };

  return { RequestSecurityCode, VerifySecurityCode, updateForgotPassword };
};
